import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { withStyles, Typography, Tooltip, IconButton } from '@material-ui/core';
import SupportedClientTypeList from './SupportedClientTypeList';
import { hasPermission, createHistory } from '../../sc-utilities';
import { FindInPage } from '@material-ui/icons';

const styles = theme => ({
    "@global": {
        "[class*='paletteButtons']": {
            backgroundColor: theme.palette.primary.main,
            color: 'none',
            margin: theme.spacing(),
            '&:hover': {
                backgroundColor: theme.palette.secondary.main,
            },
        },
    },
    root: {
        width: `98.9%`,
        height: 'auto',
        paddingLeft: theme.spacing(),
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            width: '100%'
        }
    }
});

const isValidVersion = version => {
    return version !== null && version !== undefined;
};

const SupportedClientType = props => {
    const tableRef = React.createRef();
    const { columns, classes, translations, permissions } = props;
    const [redirectOptions, setRedirectOptions] = useState({ redirect: false, supportedClientTypeID: null, redirectPath: '' });

    let visible = columns && columns['SupportedClientType'];

    const tableColumns = [
        {
            title: translations["action"] || "Action", field: 'Action',
            hidden: visible ? visible['Action'] : false,
            filtering: false,
            render: rowData => <>
                {
                    hasPermission(permissions, 'supported_client_type_load') ?
                        <Tooltip title={translations["supported_client_type_details"] || "Supported client type details"}>
                            <IconButton
                                id={`supported_client_type_details_${rowData.SupportedClientTypeID}`}
                                component='div'
                                onClick={() => redirectHandler(`/admin/supported-client-type/edit?SupportedClientTypeID=${rowData.SupportedClientTypeID}`)}
                            >
                                <FindInPage />
                            </IconButton>
                        </Tooltip> : null
                }
            </>
        },
        {
            title: translations["key"] || 'Key', field: 'Key',
            hidden: visible ? visible['Key'] : false,
            filtering: true,
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.Key ? rowData.Key : translations['short_not_assigned'] || 'n/a'}</Typography>;
            }
        },
        {
            title: translations["name"] || 'Name', field: 'Name',
            hidden: visible ? visible['Name'] : false,
            filtering: true,
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.Name ? rowData.Name : translations['short_not_assigned'] || 'n/a'}</Typography>;
            }
        },
        {
            title: translations["version"] || 'Version', field: 'Version',
            hidden: visible ? visible['Version'] : false,
            filtering: false,
            render: rowData => {
                return <Typography variant={'caption'}>{isValidVersion(rowData.MajorVersion) && isValidVersion(rowData.MinorVersion) && isValidVersion(rowData.BuildNumber) ? `${rowData.MajorVersion}.${rowData.MinorVersion}.${rowData.BuildNumber}` : translations['short_not_assigned'] || 'n/a'}</Typography>;
            }
        },
        {
            title: translations["deleted"] || 'Deleted', field: 'Deleted',
            hidden: visible ? visible['Deleted'] : false,
            lookup: { '1': translations['yes'] || 'Yes', '0': translations['no'] || 'No' },
            defaultFilter: ['0'],
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.Deleted ? translations['yes'] || 'Yes' : translations['no'] || 'No'}</Typography>;
            }
        },
    ];

    const redirectHandler = (path, supportedClientTypeID = null) => {
        createHistory();
        setRedirectOptions({ redirect: true, supportedClientTypeID: supportedClientTypeID, redirectPath: path });
    };

    if (redirectOptions.redirect) {
        return <Redirect to={redirectOptions.redirectPath} />;
    }

    return (
        <div className={classes.root}>
            {
                hasPermission(permissions, 'supported_client_type_list') ?
                    <SupportedClientTypeList
                        tableColumns={tableColumns}
                        redirectHandler={redirectHandler}
                        tableRef={tableRef}
                    /> : null
            }
        </div>
    );
};

const mapStateToProps = state => {
    return {
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        columns: state.core.login.userSettings ? state.core.login.userSettings.Columns : null,
        permissions: state?.core?.login?.permissions || []
    };
}

export default connect(
    mapStateToProps,
    null
)(withStyles(styles, { withTheme: true })(SupportedClientType));
